<template>
  <div class="all">

    <div id="tablePrint" class="table_print"
      style="padding: 0px 10px;font-size: 12px;text-align: left;padding-bottom:30px">
      <div v-if="orderObj.printHeader" style="font-size:20px;font-weight: bold;">{{ orderObj.printHeader }} </div>

      <div style="text-align:center;font-size:20px;font-weight: bold;margin-bottom:10px">【{{ name }}】</div>
      <div style="text-align:center;font-size:20px;font-weight:bold;margin-bottom:10px">【{{ orderObj.restaurant }}】</div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div style="display:flex; flex-wrap:wrap; font-size:12px;">
        <div style="font-size:12px; width:40%;margin-bottom:5px">单号:{{ orderObj.orderNum }}</div>
        <div style="font-size:12px;width:40%;margin-bottom:5px">桌号:{{ orderObj.mealTableNum }}</div>
        <div style="font-size:12px;width:20%;margin-bottom:5px">人数:{{ orderObj.peopleCount }}</div>
        <div style="font-size:12px;width:40%">点餐员:{{ orderObj.userName }}</div>

        <div style="font-size:12px;width:60%;">日期:{{ orderObj.orderTime }}</div>
      </div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      <div class="table" style="padding-bottom:20px">

        <div v-for="(v, i) in printlists" :key="i" style="padding:10px 0;">
          <div style="display:flex;justify-content: space-between;font-weight:bold;">
            <div style="font-size:20px;">
              {{ v.dishesName }}
              <!-- {{ v.name }} -->
            </div>
            <div style="font-size:20px;">
              {{ orderObj.printHeader == '退菜' ? '-' : '' }} {{ v.quantity.toFixed(2) }}{{ v.unitName }}
              <!-- {{ orderObj.printHeader == '退菜' ? '-' : '' }} {{ v.number.toFixed(2) }}{{ v.unitName }} -->
            </div>
          </div>
          <div style="font-size:12px;padding-top:8px" v-if="v.remark">要求：{{ v.remark }} </div>

        </div>
      </div>

      <div style="height:2px;width:100%"></div>
      <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />
      <div v-if="remark" style="font-size:20px;font-weight: bold;">
        <div> 整单备注：{{ remark }}</div>
        <hr style="border:none;border-top:1px dashed #999;margin:6px 0px" />

      </div>
    </div>

    <div class="btn">
      <el-button @click="todoPrint('preview')" type="primary" size="mini">预览打印</el-button>
      <el-button @click="todoPrint('print')" type="primary" size="mini">打印</el-button>
    </div>

  </div>
</template>
<script>
import getLodop from '../../utils/Lodopfuncs'

export default {
  props: {
    orderObj: {
      type: Object
    },

  },
  data() {
    return {

      arr1: [],
      arr2: [],
      arr3: [],
      printnameB: "凉菜",
      printnameA: '',
      name: "",
      tableList: [],
      printlists: [],
      type: "",
      remark: undefined,
      printnumber: 0,
      stampumber: 0
    }
  },
  watch: {


  },
  computed: {

  },
  mounted() {

    this.$bus.on('printlist', value => {
      this.tableList = value
      this.printnumber = value.length
    })
    // this.$bus.on('name', value => {
    //   this.type = value
    // })
    this.$bus.$on('remark', value => {
      this.remark = value
      console.log('remarks', this.remark);

    })

  },
  created() {
    this.getTime()


  },
  methods: {


    getTime() {

      let date = new Date();
      let y = 1900 + date.getYear();
      let m = "0" + (date.getMonth() + 1);
      let d = "0" + date.getDate();
      let h = "0" + date.getHours();
      let mm = "0" + date.getMinutes();
      let s = date.getSeconds();
      this.time = y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length) + " " + h.substring(h.length - 2, h.length) + ":" + mm.substring(mm.length - 2, mm.length);

    },
    async demo(arr) {
      console.log('开始', arr);


      let oldname = '', newname, arr1 = []
      arr1.push(arr[0])
      if (arr.length == 1) {

        this.name = arr[0].printname
        this.printlists = [...arr]
        console.log(this.name, this.printlists);
        this.$nextTick(() => {
          const ab = this.todoPrint(arr[0].printname, arr)
        })
        return
      }


      for (let i = 1; i < arr.length; i++) {
        oldname = arr[0].printname
        newname = arr[i].printname
        console.log('newname', oldname, newname);
        if (oldname == newname) {
          arr1.push(arr[i])
          if (i == arr.length - 1) {
            this.name = newname
            this.printlists = [...arr1]
            console.log('打印', this.printlists);


            this.$nextTick(() => {
              const ab = this.todoPrint(oldname, arr1)
            })
          }
        } else if (oldname != newname) {
          this.name = oldname
          this.printlists = [...arr1]
          console.log('打印', this.printlists);

          this.$nextTick(() => {
            const ab = this.todoPrint(oldname, arr1)
          })

          const a = arr.slice(i)
          setTimeout(() => {
            this.demo(a)

          }, 500);
          break
        }
      }




    },

    print() {

      if (this.tableList.length > 0) {
        this.stampumber = 0


        this.demo(this.tableList)
        return


      } else {

        setTimeout(() => {
          this.print()

        }, 500);
      }


    },
    GetPrinter() {
      //获取当前打印机

      LODOP = getLodop();

      var iCount = LODOP.GET_PRINTER_COUNT();

      var PData = [];

      for (var i = 0; i < iCount; i++) {
        PData.push(LODOP.GET_PRINTER_NAME(i));
      }

      return PData;
    },
    todoPrint(name, list) {
      console.log('print.vue第215行:::打印日志', name, list);
      if (list && name) {
        this.printlists = [...list]
        this.name = name
        const LODOP = getLodop()
        setTimeout(() => {
          if (LODOP) {

            console.log('print.vue第222行:::xxxxx', document.getElementById('tablePrint').innerHTML);

            //获取打印内容
            var strFormHtml = `<body>` + document.getElementById('tablePrint').innerHTML + '</body>'   //获取打印内容
            LODOP.PRINT_INIT('') //初始化
            LODOP.SET_PRINT_PAGESIZE(1, 60, 0, '') //设置纵向
            // LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')  //设置纵向
            LODOP.ADD_PRINT_HTM('5', '20', '90%', '80%', strFormHtml)
            // LODOP.SET_PRINT_STYLEA(0, "Offset2Top", 10)
            // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
            // LODOP.SET_PRINT_STYLEA(0, "TextNeatRow", true)
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 800, '')//设置预览窗口模式和大小
            LODOP.SET_PRINT_MODE("NOCLEAR_AFTER_PRINT", true);//设置打印完毕不清理打印信息


            var PData = this.GetPrinter();

            console.log(PData, name);
            if (PData.length) {

              if (PData.indexOf(name) !== -1) {

                LODOP.SET_PRINTER_INDEXA(name);//设置某个打印机
                console.log('菜单', this.name, this.printlists);
                // LODOP.PREVIEW();

                LODOP.PRINT()

                // this.$message({
                //   message: '已向' + name + '的打印机推送任务',
                //   type: 'success'
                // });

                this.printlists = []
                this.stampumber = this.stampumber + list.length
                if (this.printnumber == this.stampumber) {
                  this.$bus.$emit('printsuccess', true)

                }
                console.log('printsuccess', this.stampumber, this.printnumber);

              } else {

                // this.$message({
                //   message: "找不到名为" + name + '的打印机',
                //   type: 'error'
                // });

                this.stampumber = this.stampumber + list.length
                console.log('printsuccess', this.stampumber, this.printnumber);

                if (this.printnumber == this.stampumber) {
                  this.$bus.$emit('printsuccess', true)
                }
                // this.$bus.$emit('printsuccess', true)
              }


            } else {
              this.$notify.error({
                title: '当前电脑无打印机'
              })
            }

            // LODOP.SET_PRINT_COPIES(2)

            // LODOP.SET_PRINTER_INDEXA(this.printnameA);//设置某个打印机
            // LODOP.PRINT()


          }
        }, 0);

      }

    },

  }

}
</script>
<style lang="scss" scoped>
#tablePrint {
  padding: 10px 15px;
  font-size: 12px;
  text-align: left;
}

.shopName {
  text-align: center;
}

.boxName {
  text-align: center;
}

.label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;

  /deep/ .el-button {
    width: 160px;
  }
}</style>